import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Vehicle } from '@app-model/vehicle';
import { OemDealerService } from '@app-services/oem-dealer.service';
import { SessionService } from '@app/store/session/session.service';
import { Role, UserInfo } from '@app/store/session/session.store';
import { SuperBidConfiguration } from '@app/views/private/admin/model/advertisers';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-superbid-management',
  templateUrl: './superbid-management.component.html',
  styleUrls: ['./superbid-management.component.scss', '../auction-management/auction-management.component.scss']
})
export class SuperbidManagementComponent implements OnInit, OnChanges {
  userInfo: UserInfo;
  @Input() vehicle: Vehicle;
  superBidConfigurations: SuperBidConfiguration[];
  selectedSuperBidConfiguration: SuperBidConfiguration;
  form: FormGroup;
  includeSubLot: boolean = false;
  isOfferActive: boolean = false;
  uptadingOffer: boolean = false;

  constructor(
    private readonly oemDealerService: OemDealerService,
    private readonly sessionService: SessionService,
    private readonly fb: FormBuilder,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit(): void {

    this.isOfferActive = this.vehicle.superBidOfferActive;
    this.uptadingOffer = this.vehicle.superBidUpdating;
    const shouldDisableGroupOffer = this.vehicle.superBidOfferActive;

    this.form = this.fb.group({
      eventId: [{ value: null, disabled: shouldDisableGroupOffer }, Validators.required],
      offerId: [{ value: null, disabled: true }],
      productId: [{ value: null, disabled: true }],
      lotNumber: [{ value: null, disabled: true }],
      subLotNumber: [{ value: null }],
      groupOfferId: [{ value: null, disabled: shouldDisableGroupOffer }],
      enableFinancing: [{ value: !!this.vehicle.superBidFinancingEnabled, disabled: shouldDisableGroupOffer }]
    })

    this.sessionService.getUser().subscribe((user) => {
      this.userInfo = user;
      this.getSuperBidIntegration();
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.vehicle.currentValue) {
      this.isOfferActive = this.vehicle.superBidOfferActive;
      this.uptadingOffer = this.vehicle.superBidOfferActive;
    }
  }


  getSuperBidIntegration() {
    if (!this.userInfo) {
      return;
    }

    if (this.userInfo.hasRole(Role.ADMIN) || this.userInfo.hasRole(Role.OEM_DEALER_MANAGER)) {
      this.oemDealerService.getSuperBidIntegration(this.vehicle.oemDealerId).subscribe((response) => {
        if (response && response.length > 0) {
          this.superBidConfigurations = response;
          if (this.superBidConfigurations?.length > 0 && this.superBidConfigurations[0].allEventsGroups) {
            this.selectedSuperBidConfiguration = this.superBidConfigurations[0];
            this.form.patchValue({
              eventId: this.selectedSuperBidConfiguration.eventId,
              offerId: this.vehicle.superBidOfferId,
              productId: this.vehicle.superBidProductId,
              lotNumber: this.vehicle.superBidLotId,
              subLotNumber: this.vehicle.superBidSubLotId,
              groupOfferId: this.vehicle.superBidGroupOfferId ? this.vehicle.superBidGroupOfferId : this.selectedSuperBidConfiguration.customEventGroups[0]?.id,
              enableFinancing: this.vehicle.superBidFinancingEnabled
            })
          }
        }
      });
    }
  }

  selectSuperBidConfiguration(event: MatSelectChange) {
    this.selectedSuperBidConfiguration = this.superBidConfigurations.find(e => e.eventId == event.value);
  }

  publishSuperBidOffer() {
    const request = this.form.getRawValue();

    if (!this.includeSubLot) {
      request.subLotNumber = null;
    }

    this.uptadingOffer = true;
    this.oemDealerService.sendAuctionToSuperBid(this.vehicle.id, request).subscribe((response) => {
      if (response.success) {
        this.toastr.success('Oferta enviada com sucesso. Em breve será publicada na Superbid.');
      }
    });
  }

  markAsSoldSuperBidOffer() {
    this.uptadingOffer = true;
    this.oemDealerService.markAsSoldSuperBidOffer(this.vehicle.id).subscribe((response) => {
      if (response.success) {
        this.toastr.success('Pedido de venda enviado com sucesso. Em breve será marcado como vendido na Superbid.');
      }
    });
  }

  cancelSuperBidOffer() {
    this.uptadingOffer = true;
    this.oemDealerService.cancelSuperBidOffer(this.vehicle.id).subscribe((response) => {
      if (response.success) {
        this.toastr.success('Pedido de cancelamento enviado com sucesso. Em breve será cancelado na Superbid.');
      }
    });
  }



}
